var $ = require('jquery');
var slick = require('slick-carousel');

module.exports = (function() {
	(function() {
		$('.brands__slider').slick({
			slidesToShow: 5,
			prevArrow: '<button type="button" class="slick-prev" style="background: none;"><i class="icon icon-slider-prev-grey"></i></button>',
			nextArrow: '<button type="button" class="slick-next" style="background: none;"><i class="icon icon-slider-next-grey"></i></button>',
			arrows: true,
			responsive: [
			    {
			      breakpoint: 1024,
			      settings: {
			        slidesToShow: 5,
			        arrows: true
			      }
			    },
			    {
			      breakpoint: 992,
			      settings: {
			        slidesToShow: 4,
			        arrows: true
			      }
			    },
			    {
			      breakpoint: 768,
			      settings: {
			        slidesToShow: 3,
			        arrows: true
			      }
			    },
			    {
			      breakpoint: 480,
			      settings: {
			        slidesToShow: 1,
			        arrows: true
			      }
			    },
			]
		});
	})();
})();
